import { LoadingScreen } from "@roberttamas/ui";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";

/**
 * Guard for the shared dashboard shell (every signed-in route, buyer and
 * admin alike): requires only a signed-in user — deliberately WITHOUT the
 * admin `listSites` gate (that's `AdminRoute`, nested inside for admin-only
 * routes), and WITHOUT requiring a verified email, so a fresh customer can
 * buy immediately. An unverified email is surfaced as a sidebar badge
 * (EmailVerificationBadge), not a wall; the backend matches this split
 * (assertSignedIn vs assertAdmin).
 */
export function AuthenticatedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
